var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefalutList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6824 24.7009H21.4602C23.775 24.7009 24.7009 23.775 24.7009 21.4602V18.6824C24.7009 16.3676 23.775 15.4417 21.4602 15.4417H18.6824C16.3676 15.4417 15.4417 16.3676 15.4417 18.6824V21.4602C15.4417 23.775 16.3676 24.7009 18.6824 24.7009Z",
    stroke: "#A4AAB2",
    strokeWidth: 0.694444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6823 19.1453C19.1936 19.1453 19.6082 18.7308 19.6082 18.2194C19.6082 17.708 19.1936 17.2935 18.6823 17.2935C18.1709 17.2935 17.7563 17.708 17.7563 18.2194C17.7563 18.7308 18.1709 19.1453 18.6823 19.1453Z",
    stroke: "#A4AAB2",
    strokeWidth: 0.694444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7517 23.2888L18.0341 21.7564C18.3999 21.511 18.9276 21.5388 19.2563 21.8212L19.4091 21.9555C19.7702 22.2657 20.3536 22.2657 20.7147 21.9555L22.6406 20.3027C23.0017 19.9925 23.585 19.9925 23.9462 20.3027L24.7008 20.9509",
    stroke: "#A4AAB2",
    strokeWidth: 0.694444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefalutList);
export default __webpack_public_path__ + "static/media/defalut-list.bcbba7e9e99e4a405ec930782ed24c19.svg";
export { ForwardRef as ReactComponent };